__turbopack_context__.v({
  "bar": "NavigationProgress-module-scss-module__hMKFua__bar",
  "complete": "NavigationProgress-module-scss-module__hMKFua__complete",
  "container": "NavigationProgress-module-scss-module__hMKFua__container",
  "fadeOut": "NavigationProgress-module-scss-module__hMKFua__fadeOut",
});
